import { useDispatch } from "react-redux";
import { IMediaListOptionsModel } from "../../models";
import { MediaStore } from "../../store";

export const useGetMediaList = () => {
  const dispatch = useDispatch();
  return (options: IMediaListOptionsModel) =>
    dispatch(MediaStore.Actions.getMediaList(options));
};
